<template>
  <div>
    <Editor
      :initialValue="editorText"
      ref="toastuiEditor"
      :options="defaultOptions"
      :initialEditType="EditType"
      previewStyle="vertical"
      height="500px"
      @blur="onUpdate()"
    />
    <div v-if="showButton != false" class="editor-button mt-3 ">
      <b-button @click="onhideModel()" :disabled="disabledSubmit" class="mr-1" variant="outline-primary"
        >ยกเลิก</b-button
      >
      <b-button @click="onSave()" :disabled="disabledSubmit" variant="primary" class="mx-2 d-inline-flex align-items-center">
        บันทึก
        <b-spinner v-if="disabledSubmit" small class="ml-1 align-middle"></b-spinner>
      </b-button>
    </div>
    <div class="text-danger text-right mx-2" v-if="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import "@toast-ui/editor/dist/toastui-editor.css";
import { mapActions, mapGetters } from "vuex";
import { Editor } from "@toast-ui/vue-editor";

export default {
  namespaced: true,
  components: {
    Editor,
  },
  props: [
    "editorText",
    "EditType",
    "showButton",
    "disabledSubmit",
    "error"
  ],

  data() {
    return {
      token: localStorage.getItem("token"),
      defaultOptions: {
        language: "th-TH",
        useCommandShortcut: false,
        usageStatistics: true,
        hideModeSwitch: true,
        toolbarItems: [
          ["heading", "bold", "italic"],
          ["ul", "ol", "indent", "outdent"],
          ["table", "link", "image"],
          ["scrollSync"],
        ],
      },
    };
  },
  mounted() {
    const editor = this.$refs.toastuiEditor.editor || this.$refs.toastuiEditor.invoke("getEditor");
    if (editor) {
      editor.removeHook("addImageBlobHook");
      editor.addHook("addImageBlobHook", async (blob, callback) => {
        const resizedBlob = await this.resizeImage(blob);
        const reader = new FileReader();
        reader.onloadend = () => {
          callback(reader.result, blob.name);
        };
        reader.readAsDataURL(resizedBlob);
      });
    }
  },
  watch: {
    editorText(newValue) {
      this.$refs.toastuiEditor.invoke("setMarkdown", newValue);
    },
  },
  computed: {
    ...mapGetters("ExamBuilder", ["exam"]),
  },
  methods: {
    ...mapActions("ExamBuilder", ["findExamsbyId"]),
    fetch() {
      this.findExamsbyId(this.exam.id);
    },
    onhideModel() {
      this.$emit("hideModal");
    },
    onSave() {
      this.$emit("onSave", this.$refs.toastuiEditor.invoke("getMarkdown"));
    },
    onUpdate() {
      this.$emit("updateDesc", this.$refs.toastuiEditor.invoke("getMarkdown"));
    },
    resizeImage(blob, maxWidth = 800, quality = 0.7) {
      return new Promise((resolve) => {
        const img = new Image();
        const objectUrl = URL.createObjectURL(blob);
        img.onload = () => {
          URL.revokeObjectURL(objectUrl);
          if (img.width <= maxWidth) {
            resolve(blob);
            return;
          }
          const ratio = maxWidth / img.width;
          const canvas = document.createElement("canvas");
          canvas.width = maxWidth;
          canvas.height = img.height * ratio;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          const mimeType = blob.type || "image/jpeg";
          canvas.toBlob(
            (resizedBlob) => resolve(resizedBlob),
            mimeType,
            quality
          );
        };
        img.onerror = () => {
          URL.revokeObjectURL(objectUrl);
          resolve(blob);
        };
        img.src = objectUrl;
      });
    },
  },
};
</script>

<style lang="css" scope>
.editor-button {
  display: flex;
  justify-content: flex-end;
}
</style>
